module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.7242/img/storefront-header-blobs.svg"